<page-container>
  <div class="modal">
    <div class="modal-content w-[90%]" [ngClass]="{
      'drilldown-modal': isDrillDownModal
    }">
    <div  *ngIf="!isDrillDownModal" class="close-icon-container">
        <button id="close-btn" aria-label="Close dialog" (click)="closeDialog()">
          <img src="assets/close-icon-black.svg" alt="close dialog" />
        </button>
      </div>
      <!-- Header for Drilldown Modal -->
        <div class="neptune-drilldown-preview-header w-full flex justify-between items-center text-neptune-default-black pb-6"
          *ngIf="isDrillDownModal">

          <!-- Preview text on the left -->
          <div class="preview-header-section flex justify-start text-neptune-default text-3xl font-normal leading-8">
            Preview
          </div>

          <!-- Close icon on the right -->
          <div class="close-icon-container w-9 h-9 flex justify-end relative overflow-hidden">
            <button id="close-btn" aria-label="Close dialog" (click)="closeDialog()">
              <img src="assets/close-icon-black.svg" alt="close dialog" />
            </button>
          </div>
        </div>

      <div class="main-tvd-content modal-content-body items-stretch gap-4 justify-center" *ngIf="!isDrillDownModal">
        <ng-container *ngIf="!isPestDivision">
          <eroi-metric
            #productivityComponent
            id="productivity"
            metricId="productivity"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="productivityData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(productivityData, 'productivity') && getProgramKeys(tvdProgramScope).includes('productivity')">
          </eroi-metric>

          <eroi-metric
            #energyComponentData
            id="energy" metricId="energy"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="energyData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(energyData, 'energy') && getProgramKeys(tvdProgramScope).includes('energy')">
          </eroi-metric>

          <eroi-metric
            #waterComponentData
            id="water"
            metricId="water"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="waterData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(waterData, 'water') && getProgramKeys(tvdProgramScope).includes('water')">
          </eroi-metric>
        </ng-container>

        <ng-container *ngIf="isPestDivision">
          <eroi-metric
            #noChargeAdditionalServicesComponent
            id="no_charge_additional_services"
            metricId="no_charge_additional_services"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="noChargeAdditionalServicesData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(noChargeAdditionalServicesData, 'no_charge_additional_services') && getProgramKeys(tvdProgramScope).includes('no-charge-additional-services')">
          </eroi-metric>

          <eroi-metric
            #generalContractorCostAvoidanceComponent
            id="general_contractor_cost_avoidance"
            metricId="general_contractor_cost_avoidance"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="generalContractorCostAvoidanceData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(generalContractorCostAvoidanceData, 'general_contractor_cost_avoidance') && getProgramKeys(tvdProgramScope).includes('general-contractor-cost-avoidance')">
          </eroi-metric>

          <eroi-metric
            #setupServicesComponent
            id="setup_services"
            metricId="setup_services"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="setupServicesData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(setupServicesData, 'setup_services') && getProgramKeys(tvdProgramScope).includes('set-up-services')">
          </eroi-metric>

          <eroi-metric
            #pestPreventionFindingsComponent
            id="pest_prevention_findings"
            metricId="pest_prevention_findings"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="pestPreventionFindingsData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(pestPreventionFindingsData, 'pest_prevention_findings') && getProgramKeys(tvdProgramScope).includes('pest-prevention-findings')">
          </eroi-metric>

          <eroi-metric
            #roomNightsSavedComponent
            id="room_nights_saved"
            metricId="room_nights_saved"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="roomNightsSavedData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(roomNightsSavedData, 'room_nights_saved') && getProgramKeys(tvdProgramScope).includes('room-nights-saved')">
          </eroi-metric>

          <eroi-metric
            #furniturePreservationAssetsComponent
            id="furniture_preservation_assets"
            metricId="furniture_preservation_assets"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="furniturePreservationAssetsData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(furniturePreservationAssetsData, 'furniture_preservation_assets') && getProgramKeys(tvdProgramScope).includes('furniture-preservation-assets')">
          </eroi-metric>

          <eroi-metric
            #furniturePreservationEnergyComponent
            id="furniture_preservation_energy"
            metricId="furniture_preservation_energy"
            [makingSelectionsState]="makingSelectionsState"
            [selectionMapping]="selectedItemsDict"
            [data]="furniturePreservationEnergyData"
            [isCostAssumptionsPreview]="true"
            [measurementSystem]="measurementSystem"
            *ngIf="!isDataZeroOrEmpty(furniturePreservationEnergyData, 'furniture_preservation_energy') && getProgramKeys(tvdProgramScope).includes('furniture-preservation-energy')">
          </eroi-metric>
        </ng-container>
        <div class="no-data-available" *ngIf="isNoDataAvailable">
          <p>No data available.</p>
        </div>
      </div>
      <div *ngIf="isDrillDownModal" class="w-full bg-white flex flex-col gap-2.5">
        <div class="w-full flex flex-col gap-6">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div *ngFor="let tile of tvdDrillInTitles" class="p-4 sm:p-6 bg-white rounded-xl border border-solid border-sky-blue flex flex-col gap-4 sm:gap-6">
              <div class="{{tile?.previewCssClass}} flex flex-col gap-4 sm:gap-6">
                <div class="{{tile?.id}}-mod-value text-neptune-color-fg-default text-3xl sm:text-4xl md:text-5xl font-bold leading-tight sm:leading-[52px]">
                  <ng-container *ngIf="tile.isCurrency && tile.modifiedValue !== 'N/A' && tile.modifiedValue !== null">
                    {{currencyCode | currencySymbol}} {{ tile.modifiedValue | number }}
                  </ng-container>
                  <ng-container *ngIf="(tile.modifiedValue !== 'N/A' && tile.modifiedValue !== null) && !tile.isCurrency">
                    {{tile.modifiedValue | number}}
                  </ng-container>
                  <ng-container *ngIf="tile.modifiedValue === 'N/A' || tile.modifiedValue === null">
                    N/A
                  </ng-container>
                </div>
                <div *ngIf="shouldShowDefault(tile)" class="{{tile?.id}}-org-value text-neptune-color-fg-default text-lg sm:text-xl font-medium leading-5 sm:leading-6">
                  Default - {{ tile.originalValue | number }}
                </div>
                <div class="{{tile?.id}}-text text-neptune-color-fg-subtle text-base sm:text-lg font-normal leading-5">
                  {{ tile.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex justify-end gap-4 border-t border-neptune-border-subtle pt-4">
        <button id="cancel-btn" class="neptune-cancel-btn neptune-button-white" (click)="closeDialog()">
          Cancel
        </button>
        <button id="save-btn" class="neptune-save-btn neptune-button-blue" (click)="onSaveClick()">
          Save
        </button>
      </div>

    </div>
  </div>
</page-container>